export default __webpack_public_path__ + "static/media/997.65e11ae8.png";